import React, { useState, useEffect } from "react";
import axios from "../plugins/axios";
import { useAppDispatch } from "../store/hooks";
import {
    Box,
    Button,
    TextField,
    Typography,
    Divider,
    Card,
    CardContent,
} from "@mui/material";
import { makeStyles } from '@mui/styles';
import AccountAutoComplete from './AccountAutoComplete';
import { setSnackAction } from "../store/slices/snackSlice";

const useStyles = makeStyles((theme) => ({
    title: {
        marginRight: theme.spacing(6),
    },
    selectAccountContainer: {
        margin: "0 auto",
        padding: theme.spacing(2),
        width: "100%",
        [theme.breakpoints.up("md")]: {
            width: 400,
        },
    },
    documentsTableContainer: {
        margin: "0 auto",
        width: "75%",
        padding: theme.spacing(4),
    },
}));

const apiUrl = process.env.REACT_APP_WORKNEST_TOOLS_API_URL;

const Saas = () => {
    const classes = useStyles();
    const dispatch = useAppDispatch();
    const [selectedAccount, setSelectedAccount] = useState();
       

    const handleAccountChange = (v) => {

        console.log({ v, selectedAccount });
        setSelectedAccount(v);
    };

    const syncCases = async() => {

        await axios.post(`${apiUrl}/saas/syncaccount/${selectedAccount.id}`)
        dispatch(setSnackAction("Message Sent", "success"));
    };

    return (
        <Box style={{ width: '300px' }}>
            <AccountAutoComplete handleAccountChange={handleAccountChange} label="Account Filter" />
            {selectedAccount?.id &&
                <Button variant="contained" color="primary" onClick={syncCases}>Sync Cases</Button>
            }
        </Box>
    );
};

export default Saas;
